module.exports = __webpack_public_path__ + "img/w-flexible_rules.b903507b.png";